import { companySchema } from "@/schema/Company";
import { documentSchema } from "@/schema/Document";
import { answerCategorySchema } from "@/schema/console/evaluation-reports/AnswerCategory";
import { resultIndexSchema } from "@/schema/console/evaluation-reports/ResultIndex";
import { z } from "zod";

export const evaluationReportSchema = z.object({
  company: companySchema,
  company_document_files: z.array(documentSchema),
  result_index: resultIndexSchema,
  answer_categories: z.array(answerCategorySchema),
  submitted_by: z.string().nullish(),
  submitted_at: z.coerce.date(),
});

export type EvaluationReport = z.infer<typeof evaluationReportSchema>;
